import React from 'react';
import PricingError from "../modules/PricingError";

const InternalPricingError = (props) => {

	return (
		<PricingError id="internal-error" handleClose={props.handleCloseError.bind(this)}>
			<p>Unfortunately an error has occurred, our team will put down their coffees and look into this right away.</p>
			<p>In the meantime, we would love it if you could try again to see if the issue persists.</p>
		</PricingError>
	);

};

export default InternalPricingError;


// WEBPACK FOOTER //
// ./resources/assets/js/elements/InternalPricingError.js